/**
 * 关于路由与页面跳转的封装
 */
import * as Tools from "./tools";
import * as Dialog from "./dialog";
import router from "../../router";


/**
 * 转网页url参数
 * @param param
 * @returns {string}
 */
export const buildQuery = function (param) {
    let param_str = "";
    if (!Tools.empty(param)) {
        for (let i in param) {
            param[i] = encodeURIComponent(param[i]);
            param_str += "&" + i + "=" + param[i];
        }
    }
    param_str = param_str.substr(1);
    return param_str;
}

/**
 * url跳转方法
 * @param url
 * @param param url参数
 * @param rep 是否替换当前页
 * @returns {boolean}
 */
export const href = function (url = '', param = {}, rep = false) {
    if (Tools.empty(url)) {
        Dialog.toast('未开放访问');
        return false;
    }

    let param_str = buildQuery(param);
    if (url.indexOf("?") < 0) {
        param_str = "?" + param_str;
    }
    let fill_url = url + param_str;
    let fill_path = fill_url.split('?')[0];

    /* 判断跳转方式 */
    if (fill_url === router.currentRoute.fullPath) {
        go(0);
        return false;
    }
    if (fill_path === router.currentRoute.path) {
        rep = true;
    }

    if (rep === true) {
        router.replace(fill_url);
    } else {
        router.push(fill_url);
    }
}

/**
 * 打开新页面
 * @param url
 * @param param
 * @param location
 */
export const open = function (url = '', param = {}, location = true) {
    if (location) {
        let routeUrl = router.resolve({
            path: url,
            query: param
        });
        window.open(routeUrl.href, '_blank');
    } else {
        let param_str = buildQuery(param);
        if (url.indexOf("?") < 0) {
            param_str = "?" + param_str;
        }
        window.open(url + param_str, '_blank');
    }
}

/**
 * 返回前页
 */
export const back = function () {
    router.back();
}

/**
 * 切换路由页面
 * @param num
 */
export const go = function (num = 0) {
    router.go(num);
}

/**
 * 获取当前页面
 */
export const getCurrentPage = function () {
    return router.currentRoute;
}

/**
 * 获取路由参数
 */
export const getUrlParams = function (urlParams) {
    const params = new URLSearchParams(urlParams);
    // 获取所有参数
    const allParams = Object.fromEntries(params.entries());
    return allParams
}